/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import _, { filter } from 'lodash';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers';
import { getRepFilter } from '../../../api/filterOptionsApi';
import { filterValue, filterRepOptions } from '../../../helpers/filterFunctions';
import useCWPContext from '../context/useCWPContext';

function Filter() {
  const { auth, setFilterForm, filterForm, monthsOptions, searchCwp, clearCwp } =
    useContext(useCWPContext);

  const date = new Date();
  const [repOptions, setRepOptions] = useState([]);

  const loadRepDropdown = async () => {
    const request = {
      department: filterValue(filterForm?.department),
      manager_id: filterValue(filterForm?.manager_id),
      month: [Number(moment(filterForm?.month_year).format('M'))],
      year: [Number(moment(filterForm?.month_year).format('YYYY'))],
    };
    const reponse = await getRepFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);
      setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleChangeDate = (value) => {
    setFilterForm({ ...filterForm, month_year: moment(value).format('YYYY-MM') });
  };

  useEffect(() => {
    loadRepDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Specialist' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <DatePicker
            label='month_year'
            views={['month', 'year']}
            value={filterForm?.month_year}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => (
              <TextField {...params} label='Month Year' size='small' fullWidth />
            )}
            onChange={(value) => handleChangeDate(value)}
          />
        </Grid>

        <Grid md={2}>
          <Button variant='contained' color='success' onClick={searchCwp}>
            Generate
          </Button>

          <Button
            variant='contained'
            color='primary'
            onClick={clearCwp}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
